import { gql, TypedDocumentNode } from "@apollo/client";

import { ApiKey } from "types/generated";

type GetApiKeysGql = {
  apiKeys: ApiKey[];
};

export const GET_API_KEYS: TypedDocumentNode<GetApiKeysGql> = gql`
  query GetApiKeysV2 {
    apiKeys {
      id
      createdAt
      creator
      description
      lastUsedAt
      teams
      name
      type
      oidcSettings {
        clientId
        issuer
        subjectExpression
      }
      teamCount
      spaceCount
    }
  }
`;
